import { useEffect } from 'react';
import { driverSupabase as supabase } from '@/integrations/supabase/driver-client';

/**
 * Tracks the driver in a Supabase Presence channel so the Admin Portal can
 * see in real time which drivers have an active socket connection (vs.
 * inferring from `last_location_updated_at` timestamps).
 *
 * Channel name: `drivers-online`
 * Tracked payload: { driver_id, online_at }
 */
export function useDriverPresence(driverId: string | undefined, isAvailable: boolean) {
  useEffect(() => {
    if (!driverId) return;

    const channel = supabase.channel('drivers-online', {
      config: { presence: { key: driverId } },
    });

    channel
      .on('presence', { event: 'sync' }, () => {
        // No-op on the driver side — admin consumes this
      })
      .subscribe(async (status) => {
        if (status === 'SUBSCRIBED') {
          await channel.track({
            driver_id: driverId,
            is_available: isAvailable,
            online_at: new Date().toISOString(),
          });
        }
      });

    return () => {
      channel.untrack().catch(() => {});
      supabase.removeChannel(channel);
    };
  }, [driverId, isAvailable]);
}
